__turbopack_context__.v({
  "actionButton": "tenantVeriSend-module-scss-module__um74mG__actionButton",
  "lgContainer": "tenantVeriSend-module-scss-module__um74mG__lgContainer",
  "mdContainer": "tenantVeriSend-module-scss-module__um74mG__mdContainer",
  "narrowContainer": "tenantVeriSend-module-scss-module__um74mG__narrowContainer",
  "pageContainer": "tenantVeriSend-module-scss-module__um74mG__pageContainer",
  "secondaryBtn": "tenantVeriSend-module-scss-module__um74mG__secondaryBtn",
  "sectionDescription": "tenantVeriSend-module-scss-module__um74mG__sectionDescription",
  "sectionTitle": "tenantVeriSend-module-scss-module__um74mG__sectionTitle",
});
